import { loginIAChatAPI } from "../components/chatia/api/chat/route";
import { clearAllData } from "../components/chatia/lib/IndexedDB";
import { variablesGlobales } from "../configs/variables";
import { AuthService } from "../services/auth/auth.service";
import { IndexedDBService } from "../services/indexedDbService";

const indexedDbService = new IndexedDBService();

export const closeSession = async () => {
    try {
        console.log('Cerrando Sesión...');
        let documento = localStorage.getItem('doc');
        let otp = localStorage.getItem('token');
        /* let chatSessionId = localStorage.getItem("chatSessionId"); */
        localStorage.clear();
        localStorage.setItem('is_signin', false);
        indexedDbService.clearStore().then(() => console.log('Almacén limpiado')).catch(e => console.log(e));
        /* clearAllData()
            .then(() => console.log('Datos borrados de almacén chatia_db'))
            .catch(e => console.log(e)); */

        //Limpiar el store de chatia_db
        /* closeSessionChatIa(chatSessionId)
            .then(() => console.log('Sesión IA cerrada'))
            .catch(e => console.log(e)); */

        try {
            let { message, error } = await AuthService.logout({ documento: documento, otp: otp });
            if (error === true) {
                console.log(message);
                return false;
            } else {
                return true;
            }
        } catch (error) {
            console.log(error);
            return false;
        }
    } catch (error) {
        console.log(error);
        return false;
    }
}

export const closeSessionChatIa = async (chatSessionId) => {
    return new Promise(async (resolve, reject) => {
        if (chatSessionId) {
            try {
                let token = await loginIAChatAPI();

                if (!token) {
                    throw new Error(`Login Chat API failed`);
                }
                let response = await fetch(`${variablesGlobales.endpointApiChatAi}/sessions`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        session_id: chatSessionId
                    }),
                });

                let data = await response.json();
                if (response.ok) {
                    resolve(data);
                } else {
                    console.log("Error closing session", data);
                    reject("Error closing session");
                }
            } catch (error) {
                console.log("Error closing session", error);
                reject("Error closing session");
            }
        } else {
            console.log("No hay sesión para cerrar");
            resolve(true);
        }
    });
}
